import { Dialog } from '@buffer-mono/popcorn'

import InstagramSelectAccountType from '../../../../exports/Orchestrator/channelConnections/components/InstagramSelectAccountType/InstagramSelectAccountType'
import type { onRedirectParams } from '../../../../exports/Orchestrator/channelConnections/types'
import { useModalManager } from '../../../ModalManager/hooks/useModalManager'

import styles from './InstagramSelectAccountType.module.css'

export function InstagramSelectAccountTypeDialog(): JSX.Element {
  const onRedirect = (args: onRedirectParams): void => {
    const { redirectUrl } = args
    window.location.assign(redirectUrl)
  }

  const { modalData: data, dismissModal: closeAction } = useModalManager()

  return (
    <Dialog
      open
      onOpenChange={(): void => {
        // custom close action
        if (data?.onCustomCloseAction) {
          data.onCustomCloseAction()
        }

        // default close action to dismiss modal
        closeAction()
      }}
    >
      <Dialog.Content className={styles.content}>
        <InstagramSelectAccountType onRedirect={onRedirect} />
      </Dialog.Content>
    </Dialog>
  )
}

export default InstagramSelectAccountTypeDialog
